// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import store from './store/root.js'

// import javascript boostrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import jquery from 'jquery'
import VueMask from 'v-mask'
import VueLoading from 'vuejs-loading-plugin'
// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Aguarde...', // default 'Loading'
  loading: false, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  //background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'] // array, object or string
})



window.$ = window.jQuery = jquery

Vue.use(VueMask);


require('./assets/vendor/js/jquery.table2excel.min.js')

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js